import { IAction } from "../model/IAction";
import { ElementType, IElement } from "../model/IProcessData";
export const SELECT_ELEMENT = "SELECT_ELEMENT";
export const REMOVE_ELEMENT_SELECTION = "REMOVE_ELEMENT_SELECTION";
import { rebuildVariableScopesAndTriggerValidationAction } from "./ValidateProcess";

export function selectElement(element: IElement): SelectElementAction {
    const selectAction = { type: SELECT_ELEMENT } as SelectElementAction;
    if (element != null) {
        if (element.type !== ElementType.SubProcessStartNode) {
            selectAction.id = element.id;
        }
    } else {
        selectAction.type = REMOVE_ELEMENT_SELECTION;
    }
    return (selectAction);
}

export interface SelectElementAction extends IAction {
    id: string;
}
